/**
 * TrainingModulePage.jsx
 * =====================
 * Page lecteur d'un module de formation spécifique.
 * Charge le module depuis le registre et le rend via TrainingModulePlayer.
 */
import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { getModuleById } from '../components/training/registry';
import TrainingModulePlayer from '../components/training/TrainingModulePlayer';

const TRAINING_DOC_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/uploads/docs/training`;

const TrainingModulePage = ({ population }) => {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const mod = getModuleById(moduleId);

  if (!mod) {
    return <Navigate to={`/docs/${population}/training`} replace />;
  }
  if (population && mod.population !== population) {
    // Sécurité : on ne sert pas un module staff côté client et vice-versa
    return <Navigate to={`/docs/${population}/training`} replace />;
  }

  return (
    <TrainingModulePlayer
      module={mod}
      onClose={() => navigate(`/docs/${population}/training`)}
      pdfDownloadUrl={`${TRAINING_DOC_BASE}/${mod.id}.pdf`}
      pptxDownloadUrl={`${TRAINING_DOC_BASE}/${mod.id}.pptx`}
    />
  );
};

export default TrainingModulePage;
